export const PUBLIC_BOOKING_WOMPI_INLINE_FLOW_VERSION =
  "public_booking_wompi_inline_v1";

export function cleanInlinePaymentValue(value) {
  return String(value == null ? "" : value).trim();
}

export function inlineDigitsOnly(value, maxLength) {
  return cleanInlinePaymentValue(value).replace(/\D/g, "").slice(0, maxLength);
}

export function formatInlineCardNumber(value) {
  const digits = inlineDigitsOnly(value, 19);
  return digits.match(/.{1,4}/g)?.join(" ") || "";
}

export function inlineCardBrand(value) {
  const digits = inlineDigitsOnly(value, 19);
  if (/^4/.test(digits)) return "visa";
  const firstTwo = Number(digits.slice(0, 2));
  const firstFour = Number(digits.slice(0, 4));
  if (
    (firstTwo >= 51 && firstTwo <= 55) ||
    (firstFour >= 2221 && firstFour <= 2720)
  ) return "mastercard";
  return "";
}

export function inlineCardFieldErrors(card = {}, now = new Date()) {
  const number = inlineDigitsOnly(card.number, 19);
  const monthRaw = inlineDigitsOnly(card.expMonth, 2);
  const yearRaw = inlineDigitsOnly(card.expYear, 2);
  const cvc = inlineDigitsOnly(card.cvc, 4);
  const cardHolder = cleanInlinePaymentValue(card.cardHolder).replace(/\s+/g, " ");
  const errors = {};

  if (cardHolder.length < 2) {
    errors.cardHolder = "Escribe el nombre como aparece en la tarjeta.";
  }
  if (number.length < 13 || number.length > 19) {
    errors.number = "Revisa el número de tarjeta.";
  }

  const month = Number(monthRaw);
  if (
    monthRaw.length !== 2 ||
    !Number.isInteger(month) ||
    month < 1 ||
    month > 12
  ) {
    errors.expMonth = "Usa un mes entre 01 y 12.";
  }
  if (yearRaw.length !== 2) {
    errors.expYear = "Usa los 2 últimos dígitos del año.";
  }

  if (!errors.expMonth && !errors.expYear) {
    const currentYear = now.getFullYear() % 100;
    const currentMonth = now.getMonth() + 1;
    const year = Number(yearRaw);
    if (
      year < currentYear ||
      (year === currentYear && month < currentMonth)
    ) {
      errors.expYear = "La tarjeta está vencida.";
    }
  }

  if (cvc.length < 3 || cvc.length > 4) {
    errors.cvc = "Usa 3 o 4 dígitos.";
  }

  return errors;
}

export function normalizeInlineCard(card = {}, now = new Date()) {
  const errors = inlineCardFieldErrors(card, now);
  if (Object.keys(errors).length) {
    throw new Error(Object.values(errors)[0] || "Revisa los datos de la tarjeta.");
  }

  return {
    number: inlineDigitsOnly(card.number, 19),
    cvc: inlineDigitsOnly(card.cvc, 4),
    exp_month: inlineDigitsOnly(card.expMonth, 2).padStart(2, "0"),
    exp_year: inlineDigitsOnly(card.expYear, 2),
    card_holder: cleanInlinePaymentValue(card.cardHolder).replace(/\s+/g, " "),
  };
}

export function isValidInlineWompiSetup(data = {}, expectedAmountInCents = 0) {
  return (
    data?.ok === true &&
    data?.flowVersion === PUBLIC_BOOKING_WOMPI_INLINE_FLOW_VERSION &&
    ((data?.environment === "sandbox" && cleanInlinePaymentValue(data?.merchantPublicKey).startsWith("pub_test_")) ||
      (data?.environment === "production" && cleanInlinePaymentValue(data?.merchantPublicKey).startsWith("pub_prod_"))) &&
    Number.isSafeInteger(data?.amountInCents) && data.amountInCents > 0 &&
    Number(data?.amountInCents || 0) === Number(expectedAmountInCents || 0) &&
    cleanInlinePaymentValue(data?.tokenization?.publicKey).includes(
      "BEGIN PUBLIC KEY"
    ) &&
    Boolean(cleanInlinePaymentValue(data?.acceptance?.permalink))
  );
}

export function inlineProviderState(data = {}) {
  const status = cleanInlinePaymentValue(data?.status).toUpperCase();
  if (data?.approved === true || status === "APPROVED") return "approved";
  if (
    data?.final === true ||
    ["DECLINED", "VOIDED", "ERROR"].includes(status)
  ) return "final";
  return "pending";
}
